
function Input({ label, type, id, placeholder, value, onChange }) {
    return (
        <div className="form-group mb-4">
            <label htmlFor={id}>{label}</label>
            <input
                type={type}
                className="form-control"
                id={id}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                required
             />
        </div>
    );
}

export default Input;
